const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_SURVEY_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case "GET_SURVEY_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
